@if (anchors().length > 0) {
  <ul class="page-anchors">
    @for (anchor of anchors(); track $index) {
      <li class="page-anchors-item" [ngStyle]="anchor.style">
        <!-- FIXME: Weirdly the directive can't get the href attribute, it's always 'undefined' -->
        <a [scrollToAnchor]="anchor.id ? ('#'+anchor.id) : undefined" class="page-anchors-btn" ngbTooltip="{{ anchor.tooltip | translate }}" placement="left" container="body" (click)="anchor.onClick?.()" [ngStyle]="anchor.aStyle">
          @if (anchor.text) {
            <span>{{ anchor.text | translate }}</span>
          }
          @if (anchor.icon) {
            <i class="far fa-{{ anchor.icon }}"></i>
          }
        </a>
      </li>
    }
  </ul>
}